import React from 'react'


const AllBlogPosts = (props: any) => {
    const { allBlogPosts } = props.data.analytics;


    return <><pre>{JSON.stringify(allBlogPosts, null, 2) }</pre></>
}


export default AllBlogPosts;